import { useMutation } from '@tanstack/react-query';
import { post } from '../libs';

interface Params {
  name: string; // 이름
  phone: string; // 핸드폰 번호
  age: number | null; // 나이 (선택 입력)
  sex?: 'MALE' | 'FEMALE' | null; // 성별 (선택 입력, enum 사용)
  allowSelfScheduling?: boolean; // 회원이 직접 일정 등록 가능한 버튼 포함된 알림톡 발송 여부 (기본값: true)
}

/**
 * 코치 - 피벗 유저가 아닌 기존 회원 등록 (이름, 연락처만 등록 - status TAKEN) -> 이후 해당 회원 가입 시 연동
 *
 * @link https://api-dev.fibud.kr/api#/%ED%9A%8C%EC%9B%90%20%EA%B4%80%EB%A6%AC/MembersController_createMember
 * @returns
 */
export function useCreateMemberMutation() {
  return useMutation((payload: Params) => post(`/members`, payload));
}
